export const inClientMode = () => {
  return typeof window !== 'undefined';
};

const LEGACY_STAGING_FIELD_URL = /^https:\/\/(number|expiry|cvv)\.dev\.appcharge-int\.com\/?$/;

/** True when runtime config.js still points at per-field dev domains. */
function isLegacyStagingFieldUrl(value: string | undefined): boolean {
  return value !== undefined && LEGACY_STAGING_FIELD_URL.test(value.trim());
}

export function getEnvVariable(key: string, fallback: string): string;
export function getEnvVariable(key: string, fallback?: undefined): string | undefined;
export function getEnvVariable(key: string, fallback?: string): string | undefined {
  if (inClientMode()) {
    const fromWindow = (window as unknown as Record<string, string | undefined>)[key];
    const fromEnv = (import.meta.env as Record<string, string | undefined>)[key];

    // Stale cached config.js on pay-staging can keep legacy number.dev URLs even
    // after the bundle was built with fields.dev. Prefer the build-time value
    // when we detect that mismatch.
    if (
      key.endsWith('_FIELD_URL') &&
      fromEnv &&
      isLegacyStagingFieldUrl(fromWindow) &&
      fromEnv.includes('fields.dev.appcharge-int.com')
    ) {
      return fromEnv;
    }

    return fromWindow || fromEnv || fallback;
  }

  return (import.meta.env as Record<string, string | undefined>)[key] || fallback;
}
